


































































































































import Vue from 'vue'

import { NotNull, Unpacked } from '@/utils'
import { CasesConnection } from '@/graphql-schema'
type Case = Unpacked<CasesConnection['nodes']>
type Patient = Case['patient']

export default Vue.extend({
  computed: {
    currentCase(): Case {
      return this.$store.getters.currentCase
    },
    patient(): Patient {
      return this.currentCase!.patient
    },
  },
})
